import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import { consumeReturnPath } from '../returnPath';
import './Auth.css';

function Login({ setIsAuthenticated }) {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    async function runSso() {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const token = params.get('token');
      if (!code && !token) return;

      setLoading(true);
      setError('');
      try {
        const response = await api.post(
          '/api/sso-login',
          code ? { code } : { token },
        );
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        navigate(consumeReturnPath() || '/dashboard', { replace: true });
      } catch (err) {
        if (!mounted) return;
        setError(err.response?.data?.error || 'SSO login failed. Please try regular login.');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    runSso();

    return () => {
      mounted = false;
    };
  }, [location.search, navigate, setIsAuthenticated]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/api/login', {
        email,
        password
      });

      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setIsAuthenticated(true);
      navigate(consumeReturnPath() || '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Invoice Generator</h1>
        <h2>The Castle Pub GmbH</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Email</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="label">Password</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;

